// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"70574ee9","239":"d78b1105","453":"716af96d","455":"245d2c10"}[chunkId] + ".chunk.js";
};